import { gql } from '@apollo/client';
import Fragments from './fragments';

export const REPORT_QUERY = gql`
  query report($reportId: Int!) {
    report(reportId: $reportId) {
      ...reportItem
      reportFilters {
        ...reportFilterItem
      }
      reportParameters {
        ...reportParameterItem
      }
      reportXDocumentTypes {
        ...reportXDocumentTypeItem
      }
      reportXPartnerTypes {
        ...reportXPartnerTypeItem
      }
      reportXUserGroups {
        ...reportXUserGroupItem
      }
    }
  }
  ${Fragments.reportItem}
  ${Fragments.reportFilterItem}
  ${Fragments.reportParameterItem}
  ${Fragments.reportXDocumentTypeItem}
  ${Fragments.reportXPartnerTypeItem}
  ${Fragments.reportXUserGroupItem}
`;

export const REPORT_TYPES_QUERY = gql`
  query reportTypes {
    reportTypes {
      value
    }
  }
`;

export const OPEN_MODES_QUERY = gql`
  query openModes {
    openModes {
      id
      value
    }
  }
`;

export const REPORT_PARTNER_TYPES_QUERY = gql`
  query reportPartnerTypes {
    reportPartnerTypes {
      id
      name
    }
  }
`;

export const REPORT_DOCUMENT_TYPES_QUERY = gql`
  query reportDocumentTypes {
    reportDocumentTypes {
      id
      name
    }
  }
`;

export const REPORT_PARAMETER_TYPES_QUERY = gql`
  query reportParameterTypes {
    reportParameterTypes {
      id
      code
      name
    }
  }
`;

export const REPORT_CONTEXT_PARAMETERS_QUERY = gql`
  query reportContextParameters {
    reportContextParameters {
      id
      value
    }
  }
`;

export const DICTIONARY_EDITOR_TYPES_QUERY = gql`
  query dictionaryEditorTypes {
    dictionaryEditorTypes {
      dictionaryItemId
      dictionaryItemCode
    }
  }
`;
